import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DeviceState } from './device.state';

export const selectDevice = createFeatureSelector<DeviceState>('device');

export const selectIsMobile = createSelector(
  selectDevice,
  (state: DeviceState) => state.isMobile,
);
